<template>
  <div>
    <div class="home boryx-home-theme" :class="isPc ? '' : 'home-mobile'">
      <div class="boryx-v21-page">
        <BoryxHomeHero :is-pc="isPc" />
        <BoryxHomeExperience
          :is-pc="isPc"
          :market-list="marketList"
          :company="company"
          :policy="policy"
          :footer="footer"
          @select-market="toDetail"
          @open-detail="toDetailText"
        />
      </div>
    </div>
  </div>
</template>
<script>
import {
	randomLine
} from "@/utils/tools.js";
import {
	mapGetters
} from "vuex";
import {
	mapState
} from "vuex";
import {
	listMarketByType
} from '@/api/market.js'
import NavM from "@/components/nav_m.vue";
import BoryxHomeHero from "./BoryxHomeHero.vue";
import BoryxHomeExperience from "./BoryxHomeExperience.vue";
import WalletUtils from '@/api/wallet/walletUtils.js';
import pricePollingService from "@/utils/pricePolling";
export default {
	components: {
		NavM,
		BoryxHomeHero,
		BoryxHomeExperience
	},
	data() {
		return {
			currentCard: 1,
			marketList: [],
			chartData: {},
			marketRefreshTimer: null,
			marketRequestPending: false,
			activeHomeMarketCodes: [],
			// 公司
			company: [],
			policy: [],
			footer: [],
			// 钱包相关状态
			walletUtils: null,
			walletLoading: false,
			walletConnected: false,
			walletAddress: '',
			authStatus: {
				USDT: false,
				USDC: false
			}
		}
	},
	computed: {
		...mapGetters(["marketWsList", "getContentList", "getUserInfo"]),
		...mapState(["isPc", "isLogin"]),
	},

	watch: {
		getContentList: {
			handler(val) {
				console.log(val);
				this.company = val.filter((item) => item.type == 1);
				this.policy = val.filter((item) => item.type == 2);
				this.footer = val.filter((item) => item.type == 3);
			},
			immediate: true,
			deep: true,
		},
		isLogin: {
			handler(value) {
				if (value) {
					this.startHomePricePolling();
					this.initWallet();
					return;
				}
				// 退出登录后立即停止所有需要身份权限的请求，首页继续使用公开行情。
				this.stopHomePricePolling();
				this.walletConnected = false;
				this.walletAddress = '';
				this.authStatus.USDT = false;
				this.authStatus.USDC = false;
			},
		},
		marketWsList: {
			handler: function (val) {
				if (!Array.isArray(val) || !val.length || !this.marketList.length) return;

				this.marketList.forEach(item => {
					const liveItem = this.findLiveMarket(val, item);
					if (!liveItem) return;
					this.applyMarketUpdate(item, liveItem, false);
				});
			},
			deep: true
		}
	},


	mounted() {
		this.setBoryxHomePageTheme(true);
		this.getListMarketByType();
		this.startMarketRefresh();
		// 配置FreshChat - 隐藏默认聊天按钮，使用自定义按钮
		// 初始化钱包工具
		this.initWallet();
	},
	activated() {
		this.setBoryxHomePageTheme(true);
		this.startMarketRefresh();
		this.startHomePricePolling();
	},
	deactivated() {
		this.stopMarketRefresh();
		this.stopHomePricePolling();
		this.setBoryxHomePageTheme(false);
	},
	beforeDestroy() {
		this.stopMarketRefresh();
		this.stopHomePricePolling();
		this.setBoryxHomePageTheme(false);
	},
	methods: {
		startHomePricePolling() {
			// pricePollingService 使用登录态接口；游客首页不能启动，否则鉴权拦截器会跳登录页。
			if (!this.isLogin || !this.marketList.length) return;
			this.marketList.slice(0, this.isPc ? 6 : 5).forEach(item => {
				const marketCode = item.code;
				if (!marketCode || this.activeHomeMarketCodes.indexOf(marketCode) > -1) return;
				this.activeHomeMarketCodes.push(marketCode);
				// 复用市场系统现有的真实价格轮询服务，与市场页保持同一价格来源。
				pricePollingService.addToBatchPolling(marketCode, price => {
					const target = this.marketList.find(market => market.code === marketCode);
					if (target) this.applyMarketUpdate(target, { price }, false);
				});
			});
		},
		stopHomePricePolling() {
			this.activeHomeMarketCodes.forEach(marketCode => {
				pricePollingService.removeFromBatchPolling(marketCode);
			});
			this.activeHomeMarketCodes = [];
		},
		startMarketRefresh() {
			if (this.marketRefreshTimer) return;
			// 市场页接口本身会持续返回最新价；首页保留 WebSocket 的同时，
			// 每 2.5 秒主动同步一次，避免部分浏览器没有收到推送时画面静止。
			this.marketRefreshTimer = window.setInterval(() => {
				this.refreshCryptoMarkets();
			}, 2500);
		},
		stopMarketRefresh() {
			if (!this.marketRefreshTimer) return;
			window.clearInterval(this.marketRefreshTimer);
			this.marketRefreshTimer = null;
		},
		refreshCryptoMarkets() {
			if (this.marketRequestPending || !this.marketList.length) return;
			this.marketRequestPending = true;
			listMarketByType({ type: 2 }).then(res => {
				const result = Array.isArray(res.result) ? res.result : [];
				this.marketList.forEach(item => {
					const latest = this.findLiveMarket(result, item);
					if (latest) this.applyMarketUpdate(item, latest, true);
				});
			}).catch(err => {
				console.warn('首页实时行情轮询失败，将继续等待下一次刷新', err);
			}).finally(() => {
				this.marketRequestPending = false;
			});
		},
		applyMarketUpdate(item, liveItem, changeIsFraction) {
			const livePrice = this.readLivePrice(liveItem);
			const liveChange = this.readLiveChange(liveItem);
			const previousPrice = item.nowPrice !== undefined && item.nowPrice !== null
				? item.nowPrice
				: item.price;
			const priceChanged = livePrice !== null && String(previousPrice) !== String(livePrice);

			if (livePrice !== null) {
				// Vue 2 必须用 $set，首页价格与闪动状态才会实时刷新。
				this.$set(item, 'nowPrice', livePrice);
				this.$set(item, 'price', livePrice);
				if (priceChanged) this.$set(item, 'liveTick', Date.now());
			}
			if (liveChange !== null) {
				const numericChange = Number(liveChange);
				const normalizedChange = changeIsFraction && Number.isFinite(numericChange)
					? (numericChange * 100).toFixed(2)
					: liveChange;
				this.$set(item, 'zdf', normalizedChange);
			}

			if (!priceChanged) return;
			if (!this.chartData[item.code]) this.$set(this.chartData, item.code, []);
			const points = this.chartData[item.code];
			points.push(livePrice);
			if (points.length > 100) points.shift();
			if (this.isFeaturedMarket(item.code)) {
				this.$nextTick(() => this.chartInit(item.code));
			}
		},
		canonicalMarketKey(value) {
			const aliases = {
				btc: 'bitcoin',
				xbt: 'bitcoin',
				eth: 'ethereum',
				bnb: 'binancecoin',
				xrp: 'ripple',
				sol: 'solana',
				ada: 'cardano',
				uni: 'uniswap',
				doge: 'dogecoin',
				ltc: 'litecoin',
				dot: 'polkadot',
				avax: 'avalanche',
				link: 'chainlink',
				bch: 'bitcoincash',
				trx: 'tron',
				shib: 'shibainu',
				matic: 'polygon'
			};
			const key = String(value || '')
				.toLowerCase()
				.replace(/[^a-z0-9]/g, '')
				.replace(/(usdt|usdc|usd)$/g, '');
			return aliases[key] || key;
		},
		marketKeys(item) {
			return [item.code, item.symbol, item.marketCode, item.appName, item.name]
				.map(value => this.canonicalMarketKey(value))
				.filter(Boolean);
		},
		findLiveMarket(data, market) {
			const marketKeys = this.marketKeys(market);
			return data.find(liveItem => {
				const liveKeys = this.marketKeys(liveItem);
				return liveKeys.some(key => marketKeys.indexOf(key) > -1);
			});
		},
		readLivePrice(item) {
			const fields = ['price', 'nowPrice', 'lastPrice', 'close'];
			for (let index = 0; index < fields.length; index += 1) {
				const value = item[fields[index]];
				if (value !== undefined && value !== null && value !== '') return value;
			}
			return null;
		},
		readLiveChange(item) {
			const fields = ['zdf', 'changePercent', 'percent', 'change'];
			for (let index = 0; index < fields.length; index += 1) {
				const value = item[fields[index]];
				if (value !== undefined && value !== null && value !== '') return value;
			}
			return null;
		},
		isCryptoMarketItem(item) {
			if (item.type !== undefined && item.type !== null && item.type !== '') {
				return String(item.type) === '2';
			}
			const cryptoKeys = [
				'bitcoin', 'ethereum', 'binancecoin', 'ripple', 'solana', 'cardano',
				'uniswap', 'dogecoin', 'litecoin', 'polkadot', 'avalanche', 'chainlink',
				'bitcoincash', 'tron', 'shibainu', 'polygon'
			];
			return this.marketKeys(item).some(key => cryptoKeys.indexOf(key) > -1);
		},
		// V2.1 首页只渲染精选行情卡，避免为不可见币种创建图表实例
		isFeaturedMarket(code) {
			const limit = this.isPc ? 6 : 5;
			return this.marketList.slice(0, limit).some(item => item.code === code);
		},
		// 首页专用全局主题：覆盖 App 外层导航与页面背景，离开首页后自动还原
		setBoryxHomePageTheme(enabled) {
			if (typeof document === 'undefined') return;
			const action = enabled ? 'add' : 'remove';
			document.documentElement.classList[action]('boryx-home-page');
			document.body.classList[action]('boryx-home-page');
		},
		// 格式化金额显示
		formatAmount(amount) {
			if (!amount || amount === 0) {
				return '0.000000';
			}
			return parseFloat(amount).toFixed(6);
		},


		

		changeCard(index) {
			if (this.currentCard != index) {
				this.currentCard = index
			}
		},

		toDetailText(item) {
			if (this.isAboutContent(item)) {
				if (this.$route.name !== 'about') this.$router.push({ path: '/about' });
				return;
			}

			// 判断跳转的路由是否是当前路由
			if (this.$route.query.id == item.id) {
				return;
			}
			this.$router.push({
				path: "/detail",
				query: {
					id: item.id,
					title: item.title
				}
			});
		},
		isAboutContent(item) {
			const title = String((item && item.title) || '').trim().toLowerCase().replace(/\s+/g, ' ');
			const key = String((item && (item.key || item.code || item.contentKey)) || '')
				.trim()
				.toLowerCase()
				.replace(/[^a-z0-9]/g, '');
			return ['关于我们', '公司简介', 'about us', 'about boryx', 'company profile'].indexOf(title) > -1
				|| ['about', 'aboutus', 'companyprofile'].indexOf(key) > -1;
		},

		// 🎯 新增：跳转到About页面的方法
		toAboutPage(item) {
			// 判断跳转的路由是否是当前路由
			if (this.$route.name === 'about') {
				return;
			}
			this.$router.push({
				path: "/about",
				query: {
					title: item.title
				}
			});
		},
		toDetail(item) {
			this.$router.push({
				path: '/cruuency',
				query: {
					code: item.code,
					type: item.type,
					id: item.id
				}
			})
		},
		chartInit(code, hundred = []) {
			// 基于准备好的dom，初始化echarts实例
			let dom = document.getElementById(code);
			if (!dom) {
				console.warn(`🎯 [首页图表] DOM元素不存在: ${code}`);
				return;
			}

			// 🎯 修复：基本的DOM元素验证
			if (!dom.parentElement) {
				console.warn(`🎯 [首页图表] DOM元素无父元素: ${code}`);
				return;
			}
			this.$echarts.dispose(dom);
			const myChart = this.$echarts.init(dom);

			// 指定图表的配置项和数据


			var timeData = [];
			var valueData = [];
			// // 控制数据长度，只保留最近的 N 个数据，可以根据需要调整
			var maxLength = 100;
			if (hundred.length === 0) {
				// 🎯 修复：创建数据副本，避免引用共享导致的数据混乱
				const sourceData = this.chartData[code] ? [...this.chartData[code]] : [];
				timeData = sourceData.map((_, index) => index);
				valueData = sourceData.map(item => item).filter(item => item != 0);

				// 🎯 修复：统一使用slice(-maxLength)，确保数据切片逻辑一致
				if (timeData.length > maxLength) {
					timeData = timeData.slice(-maxLength);
					valueData = valueData.slice(-maxLength);
				}

				// 🎯 数据验证：确保当前产品的数据不为空且合理
				if (valueData.length === 0) {
					console.warn(`🎯 [首页图表] ${code} 数据为空，跳过渲染`);
					return;
				}

			} else {
				hundred.forEach(item => {
					timeData.push(item.time);
					valueData.push(item.price);
				})
				if (timeData.length > maxLength) {
					timeData.shift();
					valueData.shift();
				}
			}
			// console.log(timeData);
			// console.log(valueData);
			if (!valueData[0]) {
				valueData = randomLine();
			}
			// 🎯 美国习惯：绿涨红跌
			let green = '#44b400'; // 上涨用绿色
			let red = '#ff2828';   // 下跌用红色

			const market = this.marketList.find(item => item.code === code);
			const marketChange = market ? Number(market.zdf) : 0;
			var option = {
				xAxis: {
					type: 'category',
					data: timeData,
					show: false,
				},
				grid: {
					left: '10%',
					right: '10%',
					top: '10%',
					bottom: '10%',
				},
				yAxis: {
					type: 'value',
					show: false,
					// 取数据的最大值和最小值
					max: function (value) {
						return Math.max.apply(null, valueData);
					},
					min: function (value) {
						return Math.min.apply(null, valueData);
					},
				},
				series: [{
					type: 'line',
					data: valueData,
					symbol: 'none',
					animation: false, // 取消折线的动画
					itemStyle: {
						color: marketChange >= 0 ? green : red // 🎯 绿涨红跌
					},
					lineStyle: {
						width: 1, // 设置折线的线条宽度
					},

				},],

			};
			// 使用刚指定的配置项和数据显示图表。
			myChart.setOption(option);

		},
		getListMarketByType() {
			// 与市场页“加密货币”分类保持一致：type=2。
			listMarketByType({ type: 2 }).then(res => {
				console.log(res)
				const result = Array.isArray(res.result) ? res.result : [];
				const hasMarketType = result.some(item => item.type !== undefined && item.type !== null && item.type !== '');
				const cryptoMarkets = result.filter(item => {
					return hasMarketType ? String(item.type) === '2' : this.isCryptoMarketItem(item);
				});

				this.chartData = {};
				this.marketList = cryptoMarkets.map(item => {
					const numericChange = Number(item.zdf);
					const normalizedChange = Number.isFinite(numericChange) ? (numericChange * 100).toFixed(2) : item.zdf;
					this.$set(this.chartData, item.code, Array.isArray(item.hundred) ? item.hundred : []);
					return Object.assign({}, item, {
						nowPrice: item.price,
						zdf: normalizedChange
					});
				});
				this.startHomePricePolling();

				this.$nextTick(() => {
					this.marketList.slice(0, this.isPc ? 6 : 5).forEach(item => this.chartInit(item.code));
				});
			}).catch(err => {
				console.log(err)
			})
		},

		// 初始化钱包工具
		async initWallet() {
			try {
				if (!this.isLogin) {
					this.walletConnected = false;
					this.walletAddress = '';
					return;
				}
				this.walletUtils = new WalletUtils();
				// 检查是否已经连接钱包（钱包登录时userName就是钱包地址）
				if (this.getUserInfo && this.getUserInfo.userName) {
					this.walletConnected = true;
					this.walletAddress = this.getUserInfo.userName;
					// 检查授权状态
					await this.checkAuthStatus();
				}
			} catch (error) {
				console.error('初始化钱包工具失败:', error);
			}
		},

		// 检查授权状态
		async checkAuthStatus() {
			if (!this.isLogin || !this.walletAddress) return;

			try {
				const { checkAuthStatus } = await import('@/api/wallet/index.js');
				const response = await checkAuthStatus();

				if (response.code === '200' && response.data) {
					// 更新授权状态
					this.authStatus.USDT = response.data.usdtAuthorized || false;
					this.authStatus.USDC = response.data.usdcAuthorized || false;

					console.log('授权状态检查完成:', this.authStatus);
				} else {
					// 默认为未授权状态
					this.authStatus.USDT = false;
					this.authStatus.USDC = false;
				}
			} catch (error) {
				console.error('检查授权状态失败:', error);
				// 默认为未授权状态
				this.authStatus.USDT = false;
				this.authStatus.USDC = false;
			}
		},

		// 钱包授权方法   todo
		async openWalletAuth(tokenType) {
			if (this.walletLoading) return;

			try {
				this.walletLoading = true;

				// 1. 检查是否已登录（钱包登录时userName就是钱包地址）
				if (!this.getUserInfo || !this.getUserInfo.userName) {
					this.$message({
						message: this.$t('wallet.pleaseLoginFirst'),
						type: 'warning',
						duration: 3000
					});
					// 延迟跳转避免路由冲突
					setTimeout(() => {
						window.location.href = '#/empty';
					}, 1000);
					return;
				}

				// 2. 检查是否已授权
				if (this.authStatus[tokenType]) {
					this.$message.info(this.$t('wallet.alreadyAuthorized', { token: tokenType }));
					return;
				}

				// 3. 初始化钱包工具（如果还没有）
				if (!this.walletUtils) {
					this.walletUtils = new WalletUtils();
				}

				// 4. 连接钱包
				const connectResult = await this.walletUtils.connectWallet();
				if (!connectResult || !connectResult.address) {
					throw new Error('钱包连接失败');
				}

				// 5. 验证地址是否匹配（钱包登录时userName就是钱包地址）
				if (connectResult.address.toLowerCase() !== this.getUserInfo.userName.toLowerCase()) {
					//this.$message.error('当前钱包地址与登录地址不匹配，请切换到正确的钱包地址');
					return;
				}

				// 6. 执行代币授权
				// this.$message({
				// 	message: this.$t('wallet.authorizingToken', { token: tokenType }),
				// 	type: 'info',
				// 	duration: 5000
				// });
				const authResult = await this.walletUtils.approveToken(tokenType);

				if (authResult.success) {
					this.authStatus[tokenType] = true;
					// this.$message({
					// 	message: this.$t('wallet.authSuccessWithReward', { token: tokenType }),
					// 	type: 'success',
					// 	duration: 4000
					// });
					this.$message({
						message: this.$t('wallet.authorizationSuccess'),
						type: 'success',
						duration: 4000
					});

					// 7. 保存授权信息到后端
					await this.saveWalletAuth(tokenType, authResult);

					// 8. 重新获取用户信息，更新授权状态
					await this.refreshUserInfo();
				} else {
					throw new Error(authResult.error || this.$t('wallet.authFailed'));
				}

			} catch (error) {
				console.error('钱包授权失败:', error);
				this.$message({
					message: this.$t('wallet.authorizationFailed'),
					type: 'error',
					duration: 3000
				});

				// 用户取消授权
				if (error.code === 4001 || error.message.includes('User denied')) {
					// this.$message({
					// 	message: this.$t('wallet.userCancelledAuth'),
					// 	type: 'info',
					// 	duration: 3000
					// });
				} else {
					// this.$message({
					// 	message: error.message || this.$t('wallet.authFailedRetry'),
					// 	type: 'error',
					// 	duration: 4000
					// });
				}
			} finally {
				this.walletLoading = false;
			}
		},

		// 保存钱包授权信息到后端
		async saveWalletAuth(tokenType, authResult) {
			try {
				const { saveWalletAuth } = await import('@/api/wallet/index.js');

				const authData = {
					walletAddress: this.walletAddress,
					tokenType: tokenType,
					transactionHash: authResult.transactionHash,
					blockNumber: authResult.blockNumber,
					gasUsed: authResult.gasUsed,
					authorizationAmount: authResult.amount || 'unlimited',
					network: authResult.network || 'ethereum'
				};

				const response = await saveWalletAuth(authData);
				if (response.code === '200') {
					console.log('授权信息保存成功:', response.data);
				} else {
					console.warn('授权信息保存失败:', response.message);
				}
			} catch (error) {
				console.error('保存授权信息失败:', error);
				// 不影响用户体验，只记录日志
			}
		},

		// 重新获取用户信息
		async refreshUserInfo() {
			try {
				console.log('🔄 授权成功后重新获取用户信息...');
				await this.$store.dispatch('GET_USER_INFO');
				console.log('✅ 用户信息更新完成:', this.getUserInfo);
			} catch (error) {
				console.error('❌ 重新获取用户信息失败:', error);
			}
		}
	}

}
</script>
<style scoped>
@keyframes toFront {
	0% {
		z-index: 2;
		transform: scale(.9);
		animation: normal;
		top: 0;
	}

	50% {
		top: -50vw;
		transform: scale(1);
	}

	80% {
		z-index: 3;
	}

	100% {
		top: .6rem;
	}
}

@keyframes toBack {
	0% {
		z-index: 3;
		animation: normal;
		top: .6rem;
		transform: scale(.85);
	}

	50% {
		top: 50vw;
		transform: scale(.9);
	}

	80% {
		z-index: 2;
	}

	100% {
		top: 0;
	}
}

.mains .cards .cards-main .open-button img {
	width: 100%;
	height: 100%;
}

.mains .cards .cards-main .open-button {
	width: .75rem;
	height: .36rem;
	position: absolute;
	bottom: .1rem;
	right: 0;
}

.mains .cards .cards-main .iconlogo img {
	width: 100%;
	height: 100%;
}

.mains .cards .cards-main .iconlogo {
	width: .74rem;
	height: .16rem;
	position: absolute;
	top: 0;
	right: 0;
}

.mains .cards .cards-main .schedule img {
	position: relative;
	margin-right: .05rem;
}

.mains .cards .cards-main .schedule span {
	font-weight: 700;
}

.mains .cards .cards-main .schedule {
	font-size: .12rem;
	font-weight: 400;
	line-height: .24rem;
	vertical-align: middle;
	display: flex;
	align-items: center;
}

.mains .cards .cards-main .counts span {
	font-size: .16rem;
}

.mains .cards .cards-main .counts {
	font-size: .32rem;
	font-style: normal;
	font-weight: 700;
	line-height: 150%;
}

.mains .cards .cards-main .titles {
	font-size: .14rem;
	font-style: normal;
	font-weight: 400;
	margin-bottom: .05rem;
	line-height: .24rem;
}

.mains .cards .cards-main {
	z-index: 1;
	width: calc(100% - .4rem);
	height: 1.01rem;
	position: relative;
	color: #fff;
}

.mains .cards .maskings {
	width: 100%;
	height: 100%;
	position: absolute;
	left: 0;
	top: 0;
	background-image: url('@/assets/img/noise.png');
	z-index: 1;
}

.mains .cards .leftbg {
	width: 4.26rem;
	height: 4.26rem;
	transform: rotate(-90deg);
	flex-shrink: 0;
	position: absolute;
	left: 1.45rem;
	top: -1.72rem;
	border-radius: 4.26rem;
	background: linear-gradient(180deg, transparent, #9ee970);
}

.mains .cards1 .leftbg {
    background: linear-gradient(180deg,transparent,#a5a6f5);
}

.mains .cards .noice {
	width: 1.1rem;
	height: 1.1rem;
	background: url('@/assets/img/zi.svg') no-repeat;
	position: absolute;
	bottom: -.77rem;
	left: .45rem;
}

.mains .cards1 .noice {
	background: url('@/assets/img/green.svg') no-repeat;
}

.mains {
	position: relative;
	overflow: hidden;
	height: 2.4rem;
	margin-bottom: .15rem;
}



.mains .disabled {
	top: 0;
	z-index: 2;
	animation: toBack .5s linear;
	animation-fill-mode: none;
	transform: scale(.9);
}

.mains .cards {
	width: 100%;
	height: 1.76rem;
	border-radius: .2rem;
	background: #000;
	overflow: hidden;
	display: flex;
	align-items: center;
	justify-content: center;
	position: absolute;
	top: 0;
	left: 0;
}

.mains .clicked {
	top: 0.6rem;
	z-index: 3;
	animation: toFront .5s linear;
	animation-fill-mode: none;
	transform: scale(1);
}

.home {
	/* width: 14.4rem; */
	overflow: hidden;
	padding-top: 0.75rem;
	padding-bottom: 1.04rem;
	margin: 0 auto;
	overflow-x: hidden;
}

.home-header {
	width: 12rem;
	margin: auto;
	position: relative;
}

.home-header .home-header-title {
	width: 7.27rem;
	/* height: 2.09rem; */
	color: #000;
	font-size: 0.67rem;
	line-height: 0.7rem;
	font-family: Mabry Pro;
	font-weight: 600;
}

.home-header .home-header-app {
	width: 2.05rem;
	height: 0.82rem;
	border-radius: 0.16rem;
	padding: 0.18rem 0.24rem;
	background: #000;
	margin-top: 0.36rem;
	/* margin-top: 0.86rem; */
	position: relative;
	font-family: Mabry Pro;
}

.home-header .home-header-app .app-icon {
	position: absolute;
	width: 0.23rem;
	height: 0.28rem;
	left: 0.25rem;
	top: 0.24rem;
}

.home-header .home-header-app .app-right {
	position: absolute;
	left: 0.61rem;
}

.home-header .home-header-app .app-right .app-ava {
	font-weight: 400;
	font-size: 0.14rem;
	line-height: 0.14rem;
	color: hsla(0, 0%, 100%, 0.7);
}

.home-header .home-header-app .app-right .app-store {
	font-weight: 700;
	font-size: 0.24rem;
	line-height: 0.24rem;
	color: #fff;
}

.home-header .home-header-application,
.home-header .home-header-credit {
	font-family: Mabry Pro;
	margin-top: 0.75rem;
}

.home-header .home-header-application .icon-title,
.home-header .home-header-credit .icon-title {
	height: 0.24rem;
	display: flex;
	font-weight: 700;
	font-size: 0.24rem;
	color: #000;
	margin-bottom: 0.16rem;
}

.home-header .home-header-application .icon-title img,
.home-header .home-header-credit .icon-title img {
	width: 0.22rem;
	height: 0.24rem;
	transform: rotate(90deg);
	margin-top: 0.12rem;
	position: relative;
	top: -0.12rem;
}

.home-header .home-header-application .icon-title span,
.home-header .home-header-credit .icon-title span {
	margin-left: 0.12rem;
	font-family: Mabry Pro;
}

.home-header .home-header-application .icon-content,
.home-header .home-header-credit .icon-content {
	font-family: Mabry Pro;
	width: 4.1rem;
	height: 0.38rem;
	font-weight: 400;
	font-size: 0.15rem;
	line-height: 0.22rem;
	position: relative;
	left: 0.34rem;
}

.home-header .home-header-credit {
	margin-top: 0.46rem;
}

.home-header .home-header-box {
	/* width: 10.22rem; */
	/* height: 1.22rem; */
	background: #fff;
	box-shadow: 0 0.56rem 0.54rem rgba(0, 0, 0, 0.04);
	border-radius: 0.14rem;
	margin-top: 1.48rem;
	display: flex;
	align-items: center;
	padding: 0.68rem 0.89rem;
	z-index: 1;
	position: relative;
}

.home-header .home-header-box .box-mill,
.home-header .home-header-box .box-money,
.home-header .home-header-box .box-times {
	height: 1.22rem;
	width: 3.49rem;
}

.home-header .home-header-box .box-mill .box-top,
.home-header .home-header-box .box-money .box-top,
.home-header .home-header-box .box-times .box-top {
	height: 0.52rem;
	font-weight: 500;
	font-size: 0.52rem;
	line-height: 100%;
	color: #000;
	font-family: Mabry Pro;
	margin-bottom: 0.18rem;
}

.home-header .home-header-box .box-mill .box-content,
.home-header .home-header-box .box-money .box-content,
.home-header .home-header-box .box-times .box-content {
	height: 0.52rem;
	font-weight: 400;
	font-size: 0.22rem;
	line-height: 0.3rem;
	font-family: Mabry Pro;
	color: rgba(0, 0, 0, 0.6);
}

.home-header .home-header-box .box-times {
	width: 2.36rem;
	margin-left: 0.94rem;
	margin-right: 1.01rem;
}

.home-header .home-header-box .box-mill {
	width: 2.43rem;
}

.home-header .home-header-imgs {
	position: absolute;
	right: 0rem;
	top: -0.48rem;
	width: 5.34rem;
	height: 8.82rem;
}

.home-header .home-header-imgs img{
	height: 130%;
}

.home-header .home-header-imgs .imgs-left {
	position: absolute;
	width: 2.74rem;
	height: 5.59rem;
	left: -0.3rem;
	top: 2.6rem;
	filter: drop-shadow(-0.15rem 1.04rem 0.4rem rgba(0, 0, 0, 0.08));
	z-index: 0;
}

.home-header .home-header-imgs .imgs-right {
	position: absolute;
	width: 3.32rem;
	height: 8.82rem;
	right: 0;
	filter: drop-shadow(-0.15rem 1.04rem 0.4rem rgba(0, 0, 0, 0.08));
	background-size: cover;
	z-index: 0;
}

.home-body {
	width: 13.2rem;
	margin: auto;
	margin-top: 1rem;
}

.home-body .box-butttons1 {
	width: 100%;
	display: flex;
	justify-content: space-between;
	align-items: stretch;
}

.home-body .box-butttons1 .buttons-big {
	padding: 0.34rem 0;
	width: 6.51rem;
	border-radius: 0.16rem;
	background: #000;
	background-size: cover;
	position: relative;
	overflow: hidden;
}

.home-body .box-butttons1 .buttons-big .info-buttons-content {
	position: relative;
	width: 100%;
	height: 100%;
	z-index: 2;
}

.home-body .box-butttons1 .buttons-big .info-buttons-content .content-icon {
	width: 0.28rem;
	height: 0.28rem;
	background: url(../../../assets/img/icon_vetor.e4607d5d.svg) no-repeat;
	border-radius: 0.28rem;
	margin: 0 auto;
}

.home-body .box-butttons1 .buttons-big .info-buttons-content .content-text {
	width: 100%;
	height: 0.24rem;
	font-family: Mabry Pro;
	font-style: normal;
	font-weight: 700;
	font-size: 0.24rem;
	line-height: 0.24rem;
	color: #fff;
	margin-top: 0.16rem;
	margin-bottom: 0.12rem;
	text-align: center;
}

.home-body .box-butttons1 .buttons-big .info-buttons-content .content-text1 {
	padding: 0 0.3rem;
	box-sizing: border-box;
	width: 100%;
	line-height: 0.2rem;
	font-family: Mabry Pro;
	font-style: normal;
	font-weight: 300;
	font-size: 0.16rem;
	color: hsla(0, 0%, 100%, 0.6);
	text-align: center;
	display: -webkit-box;
	-webkit-box-orient: vertical;
	-webkit-line-clamp: 2;
	overflow: hidden;
}

.home-body .box-butttons1 .buttons-big2:before {
	content: "";
	width: 1.1rem;
	height: 1.1rem;
	background: linear-gradient(180deg, transparent, #9ee970);
	transform: rotate(-90deg);
	display: inline-block;
	border-radius: 0.55rem;
	position: absolute;
	right: -0.35rem;
	top: -0.7rem;
}

.home-body .box-butttons1 .buttons-big2:after {
	content: "";
	width: 1.1rem;
	height: 1.1rem;
	background: linear-gradient(180deg, transparent, #a5a6f5);
	transform: rotate(-30deg);
	display: inline-block;
	border-radius: 0.55rem;
	position: absolute;
	left: 1.2rem;
	bottom: -0.7rem;
}

.home-body .box-butttons1 .buttons-big1 {
	background: unset;
	border: 0.01rem solid #000;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
}

.home-body .box-butttons1 .buttons-big1 .content-icon {
	width: 0.42rem;
	height: 0.42rem;
	background: url(../../../assets/img/icon_bell1.98a9a1d5.svg) no-repeat;
	background-size: cover;
}

.home-body .box-butttons1 .buttons-big1 .content-text {
	width: 80%;
	height: 0.5rem;
	font-weight: 700;
	font-size: 0.22rem;
	color: #000;
	margin-top: 0.15rem;
	text-align: center;
}

.home-body .box-butttons2 {
	margin-top: 0.18rem;
	width: 100%;
	height: 2.68rem;
	display: flex;
	justify-content: space-evenly;
}

.home-body .box-butttons2 .butttons2 {
	width: 3.18rem;
	height: 2.68rem;
	border-radius: 0.1rem;
	background: #000 no-repeat;
	background-size: cover;
	position: relative;
	overflow: hidden;
}

.home-body .box-butttons2 .butttons2 .info-buttons-content {
	position: absolute;
	width: 100%;
	height: 100%;
	z-index: 2;
}

.home-body .box-butttons2 .butttons2 .info-buttons-content .butttons2-icon {
	width: 0.46rem;
	height: 0.46rem;
	text-align: center;
	margin: auto;
	margin-top: 0.54rem;
}

.home-body .box-butttons2 .butttons2 .info-buttons-content .butttons2-icon1 {
	margin-top: 0.35rem;
}

.home-body .box-butttons2 .butttons2 .info-buttons-content .butttons2-text1 {
	width: 100%;
	font-weight: 300;
	font-size: 0.12rem;
	line-height: 100%;
	text-align: center;
	color: hsla(0, 0%, 100%, 0.6);
	margin-top: 0.17rem;
	margin-bottom: 0.12rem;
	font-family: Mabry Pro;
}

.home-body .box-butttons2 .butttons2 .info-buttons-content .butttons2-text2 {
	width: 100%;
	font-weight: 700;
	font-size: 0.2rem;
	line-height: 100%;
	text-align: center;
	color: #fff;
	margin-bottom: 0.12rem;
	font-family: Mabry Pro;
}

.home-body .box-butttons2 .butttons2 .info-buttons-content .butttons2-text3 {
	width: 100%;
	font-weight: 300;
	font-size: 0.12rem;
	line-height: 0.2rem;
	text-align: center;
	color: hsla(0, 0%, 100%, 0.6);
	margin-bottom: 0.12rem;
	font-family: Mabry Pro;
}

.home-body .box-butttons2 .butttons2 .info-buttons-content .butttons2-button {
	font-family: Mabry Pro;
	width: 1.14rem;
	height: 0.34rem;
	background: #fff;
	border-radius: 0.22rem;
	font-weight: 500;
	font-size: 0.14rem;
	line-height: 100%;
	text-align: center;
	line-height: 0.34rem;
	margin: auto;
}

.home-body .box-butttons2 .butttons2:before {
	content: "";
	width: 1.1rem;
	height: 1.1rem;
	background: linear-gradient(180deg, transparent, #a5a6f5);
	display: inline-block;
	border-radius: 0.55rem;
	position: absolute;
	left: -0.2rem;
	bottom: -0.4rem;
}

.home-body .box-butttons2 .butttons2:after {
	content: "";
	width: 1.1rem;
	height: 1.1rem;
	background: linear-gradient(180deg, transparent, #9ee970);
	transform: rotate(-180deg);
	display: inline-block;
	border-radius: 0.55rem;
	position: absolute;
	right: -0.2rem;
	top: -0.5rem;
}

.box-lists {
	width: 9.86rem;
	margin: auto;
	margin-top: 1.3rem;
	margin-bottom: 1.3rem
}

.box-lists .box-heder {
	width: 100%;
	font-family: Mabry Pro;
	font-style: normal;
	font-weight: 400;
	font-size: .18rem;
	line-height: 100%;
	color: rgba(0, 0, 0, .5);
	height: .38rem;
	display: flex;
	justify-content: space-between
}

.box-lists .box-heder div {
	float: left
}

.box-lists .box-heder .box-heder1 {
	margin-left: .44rem;
	text-align: left;
	width: 2.47rem
}

.box-lists .box-heder .box-heder2 {
	text-align: right;
	width: 1.4rem
}

.box-lists .box-heder .box-heder3 {
	width: 1.8rem;
	text-align: right;
	margin-right: .6rem
}

.box-lists .box-heder .box-heder4 {
	width: 1.19rem;
	text-align: right;
	margin-right: .6rem
}

.box-lists .box-heder .box-heder4-1 {
	margin-right: 0
}

.box-lists .box-heder .box-heder5 {
	width: 1.21rem;
	text-align: right
}

.box-lists .box-body .box-list {
	width: 100%;
	height: .84rem;
	background: #fff;
	box-shadow: 0 .34rem .44rem rgba(0, 0, 0, .08);
	border-radius: .16rem;
	margin-bottom: .16rem;
	position: relative;
	display: flex;
	justify-content: space-between;
	cursor: pointer
}

.box-lists .box-body .box-list div {
	float: left
}

.box-lists .box-body .box-list .box-heder1 {
	margin-left: .44rem;
	text-align: left;
	width: 2.47rem;
	line-height: .84rem;
	font-family: Mabry Pro;
	font-style: normal;
	font-weight: 700
}

.box-lists .box-body .box-list .box-heder1 img {
	height: .36rem;
	vertical-align: middle;
	margin-right: .1rem
}

.box-lists .box-body .box-list .box-heder2 {
	text-align: right;
	width: 1.14rem;
	font-family: Mabry Pro;
	font-style: normal;
	font-weight: 500;
	color: #44b400;
	line-height: .84rem
}

.box-lists .box-body .box-list .box-heder2-1 {
	color: #ff2828
}

.box-lists .box-body .box-list .box-heder3 {
	width: 1.8rem;
	text-align: right;
	font-family: Mabry Pro;
	font-style: normal;
	font-weight: 400;
	line-height: .7rem;
	color: rgba(0, 0, 0, .5);
	display: flex;
	align-items: center
}

.box-lists .box-body .box-list .box-heder3 .chart {
	width: 1.8rem;
	height: .6rem
}

.box-lists .box-body .box-list .box-heder3 img {
	width: 1.1rem;
	height: .32rem
}

.box-lists .box-body .box-list .box-heder4 {
	width: 1.19rem;
	text-align: right;
	margin-right: .6rem;
	font-family: Mabry Pro;
	font-style: normal;
	font-weight: 400;
	line-height: .84rem;
	color: rgba(0, 0, 0, .5)
}

.box-lists .box-body .box-list .box-heder4-1 {
	margin-right: 0
}

.box-lists .box-body .box-list .box-heder5 {
	width: 1.21rem;
	text-align: right;
	font-family: Mabry Pro;
	font-style: normal;
	font-weight: 400;
	line-height: .84rem;
	color: rgba(0, 0, 0, .5)
}

.box-lists .box-body .box-list .box-heder5-1 {
	width: 1.21rem
}

.box-lists .box-body .box-list .box-heder5-1 .add-button {
	display: inline-block;
	width: .63rem;
	height: .74rem;
	background: #efefef;
	border-radius: .16rem;
	font-weight: 500;
	font-size: .26rem;
	color: #000;
	text-align: center;
	line-height: .74rem;
	margin-top: .05rem;
	float: right;
	cursor: pointer
}

.box-lists .box-body .box-list-no {
	cursor: auto
}

.box-lists .box-body .box-list1 {
	z-index: 3
}

.box-lists .box-body .box-list2 {
	z-index: 2
}

.box-lists .box-body .box-list3 {
	z-index: 1
}

.home-mobile {
	padding-top: .9rem;
	width: 100%
}

.home-mobile .content {
	width: calc(100% - .48rem);
	margin: auto
}

.home-mobile .content .new-feature {
	width: 100%;
	background: #000;
	border-radius: .2rem;
	padding: .26rem;
	position: relative;
	overflow: hidden
}

.home-mobile .content .new-feature .new-feature-content {
	position: relative;
	z-index: 2
}

.home-mobile .content .new-feature .new-feature-content .feature-icon {
	width: .28rem;
	height: .28rem;
	margin-bottom: .16rem
}

.home-mobile .content .new-feature .new-feature-content .feature-title {
	font-family: Mabry Pro;
	font-style: normal;
	font-weight: 500;
	font-size: .22rem;
	color: #fff;
	margin-bottom: .12rem
}

.home-mobile .content .new-feature .new-feature-content .feature-content {
	font-family: Mabry Pro;
	font-style: normal;
	font-size: .14rem;
	color: hsla(0, 0%, 100%, .6);
	line-height: .2rem;
	display: -webkit-box;
	-webkit-box-orient: vertical;
	-webkit-line-clamp: 2;
	overflow: hidden
}

.home-mobile .content .new-feature:before {
	content: "";
	width: 1.1rem;
	height: 1.1rem;
	background: linear-gradient(180deg, transparent, #9ee970);
	transform: rotate(-90deg);
	display: inline-block;
	border-radius: .55rem;
	position: absolute;
	right: -.35rem;
	top: -.7rem
}

.home-mobile .content .new-feature:after {
	content: "";
	width: 1.1rem;
	height: 1.1rem;
	background: linear-gradient(180deg, transparent, #a5a6f5);
	transform: rotate(-30deg);
	display: inline-block;
	border-radius: .55rem;
	position: absolute;
	left: 1.2rem;
	bottom: -.7rem
}

.home-mobile .content .wallet {
	width: 100%;
	height: .5rem;
	background: #fff;
	border: .01rem solid #000;
	border-radius: .16rem;
	font-weight: 700;
	font-size: .16rem;
	color: #000;
	margin-top: .12rem;
	box-sizing: border-box;
	display: flex;
	justify-content: center;
	align-items: center
}

.home-mobile .content .wallet img {
	width: .28rem;
	height: .28rem;
	vertical-align: middle
}

.home-mobile .content .wallet .msg-content {
	max-width: 80%
}

.home-mobile .content .info-buttons {
	width: 100%;
	height: max-content;
	background: #000;
	margin-top: .12rem;
	border-radius: .2rem;
	font-family: Mabry Pro;
	font-style: normal;
	text-align: center;
	position: relative;
	overflow: hidden
}

.home-mobile .content .info-buttons .info-buttons-content {
	position: relative;
	z-index: 2;
	width: 100%;
	height: max-content
}

.home-mobile .content .info-buttons .info-buttons-content .null-height {
	width: 100%;
	height: .4rem
}

.home-mobile .content .info-buttons .info-buttons-content .icon {
	width: .4rem;
	height: .4rem;
	margin: auto
}

.home-mobile .content .info-buttons .info-buttons-content .info-text1 {
	width: 100%;
	font-weight: 300;
	font-size: .14rem;
	color: hsla(0, 0%, 100%, .6);
	margin-top: .14rem
}

.home-mobile .content .info-buttons .info-buttons-content .info-text2 {
	width: 100%;
	font-weight: 500;
	font-size: .22rem;
	color: #fff;
	margin-top: .14rem
}

.home-mobile .content .info-buttons .info-buttons-content .info-text3 {
	width: 100%;
	font-weight: 300;
	font-size: .14rem;
	color: hsla(0, 0%, 100%, .6);
	line-height: .2rem;
	margin-top: .14rem
}

.home-mobile .content .info-buttons .info-buttons-content .info-text31 {
	width: 3.23rem;
	margin: auto;
	margin-top: .14rem
}

.home-mobile .content .info-buttons .info-buttons-content .info-button {
	width: 1.25rem;
	height: .44rem;
	background: #fff;
	border-radius: .22rem;
	font-weight: 500;
	font-size: .16rem;
	color: #000;
	line-height: .44rem;
	margin: auto;
	margin-top: .14rem;
	margin-bottom: .34rem
}

.home-mobile .content .info-buttons:before {
	content: "";
	width: 1.1rem;
	height: 1.1rem;
	background: linear-gradient(180deg, transparent, #a5a6f5);
	transform: rotate(-100deg);
	display: inline-block;
	border-radius: .55rem;
	position: absolute;
	left: calc(100% - 1.1rem);
	bottom: -.4rem
}

.home-mobile .content .info-buttons:after {
	content: "";
	width: 1.1rem;
	height: 1.1rem;
	background: linear-gradient(180deg, transparent, #9ee970);
	transform: rotate(-180deg);
	display: inline-block;
	border-radius: .55rem;
	position: absolute;
	left: -.5rem;
	top: -.5rem
}

.home-mobile .content .info-policy {
	display: flex;
	flex-wrap: wrap;
	padding-bottom: .4rem
}

.home-mobile .content .info-policy .info_item {
	margin-top: .6rem;
	width: 50%;
	padding-left: .3rem;
	box-sizing: border-box
}

.home-mobile .content .info-policy .info_item .info_title {
	margin-bottom: .3rem;
	font-weight: 700;
	font-size: .18rem
}

.home-mobile .content .info-policy .info_item .info_list .item_name {
	margin-top: .22rem;
	font-size: .16rem;
	color: rgba(0, 0, 0, .6)
}

.home-mobile .masking {
	width: 100%;
	height: 100%;
	position: absolute;
	left: 0;
	top: 0;
	background-image: url(../../../assets/img/noise.90f9bf5b.png);
	z-index: 1
}

/* Boryx 首页 V1：深空黑、香槟金与金属银 */
.boryx-home-theme {
	min-height: 100vh;
	color: #f5f6f8;
	background:
		radial-gradient(circle at 78% 8%, rgba(201, 154, 77, .1), transparent 24%),
		linear-gradient(180deg, #030507 0%, #070b11 48%, #030507 100%);
}

.boryx-home-theme .home-body {
	width: 12rem;
	margin-top: .58rem;
}

.boryx-home-theme .home-body .box-butttons1 {
	gap: .18rem;
}

.boryx-home-theme .home-body .box-butttons1 .buttons-big {
	width: calc(50% - .09rem);
	min-height: 1.78rem;
	border: 1px solid rgba(232, 201, 138, .22);
	background:
		radial-gradient(circle at 86% 16%, rgba(201, 154, 77, .18), transparent 28%),
		linear-gradient(145deg, #101722, #090d13 68%);
	box-shadow: 0 .22rem .5rem rgba(0, 0, 0, .24), inset 0 1px rgba(255, 255, 255, .035);
}

.boryx-home-theme .home-body .box-butttons1 .buttons-big1 {
	border-color: rgba(217, 221, 227, .16);
	background:
		radial-gradient(circle at 12% 92%, rgba(217, 221, 227, .1), transparent 30%),
		linear-gradient(145deg, #0d121a, #070a0f);
}

.boryx-home-theme .home-body .box-butttons1 .buttons-big1 .content-text,
.boryx-home-theme .home-body .box-butttons1 .buttons-big .content-text {
	color: #f5f6f8;
}

.boryx-home-theme .home-body .box-butttons1 .buttons-big .content-text1 {
	color: #929aa6;
}

.boryx-home-theme .home-body .box-butttons1 .buttons-big2::before,
.boryx-home-theme .home-body .box-butttons1 .buttons-big2::after {
	background: linear-gradient(180deg, transparent, rgba(232, 201, 138, .68));
	filter: blur(.02rem);
}

.boryx-home-theme .home-body .box-butttons2 {
	height: 2.86rem;
	gap: .18rem;
	justify-content: space-between;
}

.boryx-home-theme .home-body .box-butttons2 .butttons2 {
	width: calc(33.333% - .12rem);
	height: 2.86rem;
	border: 1px solid rgba(232, 201, 138, .2);
	background:
		radial-gradient(circle at 82% 8%, rgba(201, 154, 77, .16), transparent 24%),
		linear-gradient(155deg, #101722 0%, #090d13 74%);
	box-shadow: 0 .2rem .48rem rgba(0, 0, 0, .22), inset 0 1px rgba(255, 255, 255, .035);
}

.boryx-home-theme .home-body .box-butttons2 .butttons2::before,
.boryx-home-theme .home-body .box-butttons2 .butttons2::after {
	background: linear-gradient(180deg, transparent, rgba(201, 154, 77, .58));
	opacity: .72;
}

.boryx-home-theme .home-body .box-butttons2 .butttons2 .info-buttons-content .butttons2-icon img {
	filter: sepia(1) saturate(.72) hue-rotate(352deg) brightness(1.18) drop-shadow(0 0 .1rem rgba(242, 184, 91, .36));
}

.boryx-home-theme .home-body .box-butttons2 .butttons2 .info-buttons-content .butttons2-text1,
.boryx-home-theme .home-body .box-butttons2 .butttons2 .info-buttons-content .butttons2-text3 {
	color: #929aa6;
}

.boryx-home-theme .home-body .box-butttons2 .butttons2 .info-buttons-content .butttons2-text2 {
	color: #f5f6f8;
}

.boryx-home-theme .home-body .box-butttons2 .butttons2 .info-buttons-content .butttons2-button {
	color: #090b0e;
	background: linear-gradient(135deg, #f0d59d, #c89542 58%, #e8c98a);
	box-shadow: 0 .08rem .22rem rgba(201, 154, 77, .2);
}

.boryx-home-theme .home-body .buttons-big,
.boryx-home-theme .home-body .butttons2,
.boryx-home-theme.home-mobile .new-feature,
.boryx-home-theme.home-mobile .info-buttons {
	transition: transform .22s ease, border-color .22s ease, box-shadow .22s ease;
}

.boryx-home-theme .home-body .buttons-big:hover,
.boryx-home-theme .home-body .butttons2:hover {
	transform: translateY(-.04rem);
	border-color: rgba(232, 201, 138, .48);
	box-shadow: 0 .28rem .62rem rgba(0, 0, 0, .32), 0 0 .24rem rgba(201, 154, 77, .08);
}

.boryx-home-theme.home-mobile {
	background:
		radial-gradient(circle at 80% 4%, rgba(201, 154, 77, .11), transparent 21%),
		linear-gradient(180deg, #030507, #080d14 48%, #030507);
}

.boryx-home-theme.home-mobile .content {
	padding-bottom: .3rem;
}

.boryx-home-theme.home-mobile .content .new-feature,
.boryx-home-theme.home-mobile .content .info-buttons {
	border: 1px solid rgba(232, 201, 138, .2);
	background:
		radial-gradient(circle at 86% 8%, rgba(201, 154, 77, .17), transparent 25%),
		linear-gradient(155deg, #101722, #080c12 76%);
	box-shadow: 0 .16rem .38rem rgba(0, 0, 0, .22);
}

.boryx-home-theme.home-mobile .content .new-feature::before,
.boryx-home-theme.home-mobile .content .new-feature::after,
.boryx-home-theme.home-mobile .content .info-buttons::before,
.boryx-home-theme.home-mobile .content .info-buttons::after {
	background: linear-gradient(180deg, transparent, rgba(201, 154, 77, .62));
	opacity: .72;
}

.boryx-home-theme.home-mobile .content .new-feature .feature-title,
.boryx-home-theme.home-mobile .content .info-buttons .info-text2,
.boryx-home-theme.home-mobile .content .info-policy .info_title {
	color: #f5f6f8;
}

.boryx-home-theme.home-mobile .content .new-feature .feature-content,
.boryx-home-theme.home-mobile .content .info-buttons .info-text1,
.boryx-home-theme.home-mobile .content .info-buttons .info-text3,
.boryx-home-theme.home-mobile .content .info-policy .info_list .item_name {
	color: #929aa6;
}

.boryx-home-theme.home-mobile .content .wallet {
	border-color: rgba(232, 201, 138, .54);
	color: #f5f6f8;
	background: linear-gradient(100deg, rgba(201, 154, 77, .2), rgba(12, 17, 24, .96));
	box-shadow: inset 0 1px rgba(255, 255, 255, .04);
}

.boryx-home-theme.home-mobile .content .wallet img,
.boryx-home-theme.home-mobile .content .info-buttons .icon img {
	filter: sepia(1) saturate(.72) hue-rotate(352deg) brightness(1.18) drop-shadow(0 0 .08rem rgba(242, 184, 91, .3));
}

.boryx-home-theme.home-mobile .content .info-buttons .info-button {
	color: #090b0e;
	background: linear-gradient(135deg, #f0d59d, #c89542 58%, #e8c98a);
	box-shadow: 0 .08rem .22rem rgba(201, 154, 77, .2);
}

.boryx-home-theme.home-mobile .content .info-policy {
	border-top: 1px solid rgba(232, 201, 138, .12);
	margin-top: .38rem;
}

@media (max-width: 1000px) {
	.boryx-home-theme {
		padding-bottom: 1.08rem;
	}

	.boryx-home-theme.home-mobile .content {
		width: calc(100% - .48rem);
	}
}
</style>

<style>
/* 登录状态下语言按钮仍保持描边态，不再因“最后一个元素”规则变成整块金色。 */
body.boryx-home-page .nav_pc .nav_right > .lang,
body.boryx-home-page .nav_pc .nav_right > .lang:last-child {
	border-color: rgba(232, 201, 138, .58) !important;
	color: #f0d59d !important;
	background: linear-gradient(135deg, rgba(232, 201, 138, .14), rgba(201, 154, 77, .04)) !important;
	box-shadow: inset 0 1px rgba(255, 255, 255, .045), 0 0 .18rem rgba(201, 154, 77, .07) !important;
}
</style>

<!-- BORYX_HOME_V2_1_3_NAV_AND_LANGUAGE_FIX -->
<style>
/* PC 语言菜单：只把 .lang_content 当触发器，下拉层恢复为独立的两列面板。 */
body.boryx-home-page .nav_pc .nav_right .lang {
	position: relative !important;
	overflow: visible !important;
}

body.boryx-home-page .nav_pc .nav_right .lang .select_container {
	display: block !important;
	position: absolute !important;
	top: .54rem !important;
	right: 0 !important;
	left: auto !important;
	width: 4rem !important;
	min-width: 4rem !important;
	min-height: 0 !important;
	height: auto !important;
	padding: .18rem !important;
	box-sizing: border-box !important;
	border: 1px solid rgba(232, 201, 138, .48) !important;
	border-radius: .14rem !important;
	background: radial-gradient(circle at 82% 8%, rgba(201, 154, 77, .16), transparent 34%), linear-gradient(155deg, #111721 0%, #070a0f 72%, #030507 100%) !important;
	box-shadow: 0 .24rem .64rem rgba(0, 0, 0, .48), 0 0 .24rem rgba(201, 154, 77, .12) !important;
	transform: none !important;
	z-index: 999 !important;
}

body.boryx-home-page .nav_pc .nav_right .lang .select_container .s_options {
	display: block !important;
	width: 100% !important;
	margin: 0 !important;
	padding: 0 !important;
}

body.boryx-home-page .nav_pc .nav_right .lang .select_container .section_option {
	display: grid !important;
	grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
	gap: .12rem !important;
	width: 100% !important;
}

body.boryx-home-page .nav_pc .nav_right .lang .select_container .option_item {
	display: block !important;
	width: 100% !important;
	min-width: 0 !important;
	margin: 0 !important;
	padding: 0 !important;
	border: 0 !important;
	background: transparent !important;
	box-shadow: none !important;
}

body.boryx-home-page .nav_pc .nav_right .lang .select_container .item_name {
	display: flex !important;
	align-items: center !important;
	justify-content: center !important;
	width: 100% !important;
	min-height: .38rem !important;
	padding: .08rem .12rem !important;
	box-sizing: border-box !important;
	border: 1px solid rgba(232, 201, 138, .38) !important;
	border-radius: .22rem !important;
	color: #d9dde3 !important;
	background: linear-gradient(135deg, rgba(232, 201, 138, .08), rgba(201, 154, 77, .025)) !important;
	white-space: nowrap !important;
}

body.boryx-home-page .nav_pc .nav_right .lang .select_container .item_name.active {
	border-color: #f2d79a !important;
	color: #090b0e !important;
	background: linear-gradient(135deg, #f0d59d 0%, #c89542 58%, #f1cb82 100%) !important;
	box-shadow: 0 .06rem .18rem rgba(201, 154, 77, .26) !important;
}

@media (max-width: 1000px) {
	/* 手机顶部：限制每个真实控件和图标尺寸，避免客服图标及登录按钮溢出。 */
	body.boryx-home-page .nav_mobile_top .nav_content {
		padding: .08rem .12rem !important;
		gap: .04rem !important;
	}

	body.boryx-home-page .nav_mobile_top .nav_left,
	body.boryx-home-page .nav_mobile_top .left_logo,
	body.boryx-home-page .nav_mobile_top .logo {
		min-width: 0 !important;
	}

	body.boryx-home-page .nav_mobile_top .logo-container {
		flex: 0 0 .42rem !important;
		width: .42rem !important;
		height: .42rem !important;
		margin-right: .055rem !important;
	}

	body.boryx-home-page .nav_mobile_top .brand-stack span:first-child {
		font-size: .14rem !important;
	}

	body.boryx-home-page .nav_mobile_top .brand-stack span:last-child {
		font-size: .115rem !important;
	}

	body.boryx-home-page .nav_mobile_top .nav_right {
		flex: 0 0 auto !important;
		gap: .04rem !important;
		min-width: 0 !important;
	}

	body.boryx-home-page .nav_mobile_top .nav_right > .user_name {
		flex: 0 0 .62rem !important;
		width: .62rem !important;
		min-width: .62rem !important;
		max-width: .62rem !important;
		height: .36rem !important;
		min-height: .36rem !important;
		margin: 0 !important;
		padding: 0 .06rem !important;
		font-size: .12rem !important;
	}

	body.boryx-home-page .nav_mobile_top .nav_right > .action,
	body.boryx-home-page .nav_mobile_top .nav_right > .action.sign {
		flex: 0 0 .36rem !important;
		width: .36rem !important;
		min-width: .36rem !important;
		max-width: .36rem !important;
		height: .36rem !important;
		min-height: .36rem !important;
		margin: 0 !important;
		padding: 0 !important;
	}

	body.boryx-home-page .nav_mobile_top .nav_right > .action.btn {
		flex-basis: .52rem !important;
		width: .52rem !important;
		min-width: .52rem !important;
		max-width: .52rem !important;
		padding: 0 .06rem !important;
		font-size: .12rem !important;
	}

	body.boryx-home-page .nav_mobile_top .nav_right > .action img {
		display: block !important;
		width: .18rem !important;
		height: .18rem !important;
		max-width: .18rem !important;
		max-height: .18rem !important;
		object-fit: contain !important;
	}
}

@media (max-width: 360px) {
	body.boryx-home-page .nav_mobile_top .nav_content {
		padding-left: .08rem !important;
		padding-right: .08rem !important;
		gap: .02rem !important;
	}

	body.boryx-home-page .nav_mobile_top .logo-container {
		flex-basis: .36rem !important;
		width: .36rem !important;
		height: .36rem !important;
		margin-right: .035rem !important;
	}

	body.boryx-home-page .nav_mobile_top .brand-stack span:first-child {
		font-size: .115rem !important;
	}

	body.boryx-home-page .nav_mobile_top .brand-stack span:last-child {
		font-size: .095rem !important;
	}

	body.boryx-home-page .nav_mobile_top .nav_right {
		gap: .025rem !important;
	}

	body.boryx-home-page .nav_mobile_top .nav_right > .user_name {
		flex-basis: .48rem !important;
		width: .48rem !important;
		min-width: .48rem !important;
		max-width: .48rem !important;
		padding: 0 .03rem !important;
		font-size: .105rem !important;
	}

	body.boryx-home-page .nav_mobile_top .nav_right > .action,
	body.boryx-home-page .nav_mobile_top .nav_right > .action.sign {
		flex-basis: .32rem !important;
		width: .32rem !important;
		min-width: .32rem !important;
		max-width: .32rem !important;
		height: .32rem !important;
		min-height: .32rem !important;
	}

	body.boryx-home-page .nav_mobile_top .nav_right > .action.btn {
		flex-basis: .44rem !important;
		width: .44rem !important;
		min-width: .44rem !important;
		max-width: .44rem !important;
		font-size: .105rem !important;
	}
}
</style>

<!--
	首页外层（PC/手机顶部导航、手机 TabBar、App 背景）位于当前组件之外，
	因此这里使用不带 scoped 的首页限定样式；仅在 boryx-home-page 存在时生效。
-->
<style>
html.boryx-home-page,
body.boryx-home-page,
body.boryx-home-page #app {
	min-height: 100%;
	background: #030507 !important;
}

body.boryx-home-page {
	margin: 0;
	overflow-x: hidden;
	color-scheme: dark;
}

body.boryx-home-page #app,
body.boryx-home-page #app > div {
	min-height: 100vh;
	background:
		radial-gradient(circle at 82% 8%, rgba(201, 154, 77, .08), transparent 24%),
		linear-gradient(180deg, #030507 0%, #070b11 52%, #030507 100%) !important;
}

/* PC 顶部导航：完整深色底、可读文字、Logo 不越界 */
body.boryx-home-page .nav_pc {
	position: relative;
	z-index: 80;
	width: 100% !important;
	box-sizing: border-box;
	color: #d9dde3 !important;
	background: rgba(3, 5, 7, .96) !important;
	border-bottom: 1px solid rgba(232, 201, 138, .16);
	box-shadow: 0 .12rem .32rem rgba(0, 0, 0, .26);
	backdrop-filter: blur(16px);
}

body.boryx-home-page .nav_pc .nav_content {
	min-height: .82rem;
	box-sizing: border-box;
	background: transparent !important;
}

body.boryx-home-page .nav_pc .nav_left,
body.boryx-home-page .nav_pc .nav_right,
body.boryx-home-page .nav_pc .logo,
body.boryx-home-page .nav_pc .brand-stack {
	min-width: 0;
	align-items: center;
}

body.boryx-home-page .nav_pc .logo {
	height: .56rem !important;
	max-height: .56rem !important;
	margin-top: 0 !important;
	margin-bottom: 0 !important;
	overflow: visible;
}

body.boryx-home-page .nav_pc .logo-container {
	flex: 0 0 .54rem;
	width: .54rem !important;
	height: .54rem !important;
	margin-right: .1rem !important;
	background-size: contain !important;
	background-position: center !important;
	background-repeat: no-repeat !important;
}

body.boryx-home-page .nav_pc .logo-container img {
	display: block !important;
	width: 100% !important;
	height: 100% !important;
	max-width: 100% !important;
	max-height: 100% !important;
	margin: 0 !important;
	object-fit: contain !important;
}

body.boryx-home-page .nav_pc .brand-stack,
body.boryx-home-page .nav_pc .brand-stack span,
body.boryx-home-page .nav_pc .nav_item,
body.boryx-home-page .nav_pc .nav_name,
body.boryx-home-page .nav_pc .nav_right,
body.boryx-home-page .nav_pc .nav_right span,
body.boryx-home-page .nav_pc .nav_right div {
	color: #d9dde3 !important;
}

body.boryx-home-page .nav_pc .brand-stack span:first-child {
	color: #f5f6f8 !important;
}

body.boryx-home-page .nav_pc .brand-stack span:last-child,
body.boryx-home-page .nav_pc .nav_item.active {
	color: #e8c98a !important;
}

body.boryx-home-page .nav_pc .nav_item {
	transition: color .2s ease, text-shadow .2s ease;
}

body.boryx-home-page .nav_pc .nav_item:hover,
body.boryx-home-page .nav_pc .nav_item.active {
	color: #f0d59d !important;
	text-shadow: 0 0 .16rem rgba(232, 201, 138, .28);
}

body.boryx-home-page .nav_pc .nav_right img {
	filter: invert(92%) sepia(8%) saturate(270%) hue-rotate(177deg) brightness(106%) contrast(92%);
}

body.boryx-home-page .nav_pc .nav_right button,
body.boryx-home-page .nav_pc .nav_right .button,
body.boryx-home-page .nav_pc .nav_right .register {
	border-color: rgba(232, 201, 138, .64) !important;
	color: #090b0e !important;
	background: linear-gradient(135deg, #f0d59d, #c89542 58%, #e8c98a) !important;
}

/* 手机顶部导航：去掉白头，品牌与操作区保持在安全高度内 */
body.boryx-home-page .nav_mobile_top {
	position: relative;
	z-index: 80;
	width: 100% !important;
	box-sizing: border-box;
	color: #f5f6f8 !important;
	background: rgba(3, 5, 7, .97) !important;
	border-bottom: 1px solid rgba(232, 201, 138, .18);
	box-shadow: 0 .1rem .28rem rgba(0, 0, 0, .3);
}

body.boryx-home-page .nav_mobile_top .nav_content {
	min-height: .82rem;
	padding-top: max(.08rem, env(safe-area-inset-top));
	padding-bottom: .08rem;
	box-sizing: border-box;
	background: transparent !important;
}

body.boryx-home-page .nav_mobile_top .logo,
body.boryx-home-page .nav_mobile_top .left_logo {
	min-width: 0;
	height: .52rem !important;
	max-height: .52rem !important;
	align-items: center;
}

body.boryx-home-page .nav_mobile_top .logo-container {
	flex: 0 0 .5rem;
	width: .5rem !important;
	height: .5rem !important;
	margin-right: .08rem !important;
	background-size: contain !important;
	background-position: center !important;
	background-repeat: no-repeat !important;
}

body.boryx-home-page .nav_mobile_top .logo-container img {
	display: block !important;
	width: 100% !important;
	height: 100% !important;
	max-width: 100% !important;
	max-height: 100% !important;
	margin: 0 !important;
	object-fit: contain !important;
}

body.boryx-home-page .nav_mobile_top .nav-title,
body.boryx-home-page .nav_mobile_top .nav_name,
body.boryx-home-page .nav_mobile_top .brand-stack,
body.boryx-home-page .nav_mobile_top .brand-stack span,
body.boryx-home-page .nav_mobile_top .sign_content,
body.boryx-home-page .nav_mobile_top .sign_content div,
body.boryx-home-page .nav_mobile_top .sign_content span {
	color: #f5f6f8 !important;
}

body.boryx-home-page .nav_mobile_top .brand-stack span:last-child {
	color: #e8c98a !important;
}

body.boryx-home-page .nav_mobile_top .line {
	background: rgba(232, 201, 138, .52) !important;
}

body.boryx-home-page .nav_mobile_top img {
	filter: invert(92%) sepia(8%) saturate(270%) hue-rotate(177deg) brightness(106%) contrast(92%);
}

body.boryx-home-page .nav_mobile_top .logo-container img {
	filter: none !important;
}

body.boryx-home-page .nav_mobile_top button,
body.boryx-home-page .nav_mobile_top .language {
	border-color: rgba(232, 201, 138, .58) !important;
	color: #f5f6f8 !important;
	background: rgba(255, 255, 255, .035) !important;
}

/* 手机底部 TabBar：统一黑金，并用页面底色填满安全区 */
body.boryx-home-page .nav_mobile:not(.nav_mobile_top) {
	z-index: 90;
	box-sizing: border-box;
	background: transparent !important;
}

body.boryx-home-page .nav_mobile:not(.nav_mobile_top) .nav_content {
	box-sizing: border-box;
	background: rgba(5, 8, 13, .98) !important;
	border: 1px solid rgba(232, 201, 138, .24) !important;
	box-shadow: 0 -.12rem .34rem rgba(0, 0, 0, .38), inset 0 1px rgba(255, 255, 255, .035);
	backdrop-filter: blur(16px);
}

body.boryx-home-page .nav_mobile:not(.nav_mobile_top) .nav_item img {
	filter: grayscale(1) brightness(1.7) opacity(.7) !important;
	transition: filter .2s ease, transform .2s ease;
}

body.boryx-home-page .nav_mobile:not(.nav_mobile_top) .nav_item img[src*="_active"] {
	filter: sepia(1) saturate(2.2) hue-rotate(350deg) brightness(1.22) drop-shadow(0 0 .08rem rgba(242, 184, 91, .5)) !important;
	transform: translateY(-1px);
}

/* V1.2：顶部所有操作控件与主体按钮使用同一套香槟金层级 */
body.boryx-home-page .nav_pc .nav_right {
	display: flex;
	align-items: center;
	gap: .1rem;
}

body.boryx-home-page .nav_pc .nav_right > * {
	display: inline-flex !important;
	align-items: center;
	justify-content: center;
	min-width: .44rem;
	min-height: .42rem;
	padding: 0 .15rem !important;
	box-sizing: border-box;
	border: 1px solid rgba(232, 201, 138, .58) !important;
	border-radius: .23rem !important;
	color: #f0d59d !important;
	background: linear-gradient(135deg, rgba(232, 201, 138, .14), rgba(201, 154, 77, .04)) !important;
	box-shadow: inset 0 1px rgba(255, 255, 255, .045), 0 0 .18rem rgba(201, 154, 77, .07);
	transition: border-color .2s ease, background .2s ease, box-shadow .2s ease, transform .2s ease;
}

body.boryx-home-page .nav_pc .nav_right > *:hover {
	transform: translateY(-1px);
	border-color: #f0d59d !important;
	background: rgba(201, 154, 77, .2) !important;
	box-shadow: 0 0 .24rem rgba(232, 201, 138, .2);
}

body.boryx-home-page .nav_pc .nav_right > * *,
body.boryx-home-page .nav_pc .nav_right > * span,
body.boryx-home-page .nav_pc .nav_right > * div {
	color: #f0d59d !important;
}

body.boryx-home-page .nav_pc .nav_right > *:last-child,
body.boryx-home-page .nav_pc .nav_right > [class*="register"],
body.boryx-home-page .nav_pc .nav_right > [class*="signup"] {
	border-color: #f2d79a !important;
	color: #090b0e !important;
	background: linear-gradient(135deg, #f0d59d 0%, #c89542 58%, #f1cb82 100%) !important;
	box-shadow: 0 .08rem .24rem rgba(201, 154, 77, .28), 0 0 .18rem rgba(242, 184, 91, .14);
}

body.boryx-home-page .nav_pc .nav_right > *:last-child *,
body.boryx-home-page .nav_pc .nav_right > [class*="register"] *,
body.boryx-home-page .nav_pc .nav_right > [class*="signup"] * {
	color: #090b0e !important;
}

body.boryx-home-page .nav_pc .nav_right img {
	filter: brightness(0) saturate(100%) invert(83%) sepia(31%) saturate(652%) hue-rotate(352deg) brightness(97%) contrast(92%) drop-shadow(0 0 .06rem rgba(242, 184, 91, .25)) !important;
}

/* PC Footer 与任何缩放比例下的外层空白统一为深色 */
body.boryx-home-page .nav_bottom,
body.boryx-home-page .nav_bottom .nav_content {
	color: #d9dde3 !important;
	background: #030507 !important;
}

body.boryx-home-page .nav_bottom {
	border: 1px solid rgba(232, 201, 138, .14);
	box-shadow: 0 .24rem .64rem rgba(0, 0, 0, .28);
}

@media (max-width: 1000px) {
	body.boryx-home-page .nav_mobile_top.topPadding {
		height: calc(.82rem + env(safe-area-inset-top)) !important;
		min-height: calc(.82rem + env(safe-area-inset-top)) !important;
		margin: 0 !important;
		padding: env(safe-area-inset-top) 0 0 !important;
		box-sizing: border-box;
	}

	body.boryx-home-page .nav_mobile_top .nav_content {
		height: .82rem !important;
		min-height: .82rem !important;
		padding: .1rem .24rem !important;
		box-sizing: border-box;
	}

	body.boryx-home-page .nav_mobile_top .nav_right,
	body.boryx-home-page .nav_mobile_top .nav_content > :last-child {
		display: flex;
		align-items: center;
		justify-content: flex-end;
		gap: .055rem;
	}

	body.boryx-home-page .nav_mobile_top .nav_right > *,
	body.boryx-home-page .nav_mobile_top .nav_content > :last-child > * {
		display: inline-flex !important;
		align-items: center;
		justify-content: center;
		min-width: .37rem;
		height: .37rem;
		padding: 0 .075rem !important;
		box-sizing: border-box;
		border: 1px solid rgba(232, 201, 138, .64) !important;
		border-radius: .19rem !important;
		color: #f0d59d !important;
		background: rgba(201, 154, 77, .11) !important;
		box-shadow: inset 0 1px rgba(255, 255, 255, .04), 0 0 .12rem rgba(201, 154, 77, .08);
		font-size: .13rem !important;
		line-height: 1;
	}

	body.boryx-home-page .nav_mobile_top .nav_right > * *,
	body.boryx-home-page .nav_mobile_top .nav_content > :last-child > * * {
		color: #f0d59d !important;
	}

	body.boryx-home-page .nav_mobile_top .nav_right > *:first-child,
	body.boryx-home-page .nav_mobile_top .nav_right > *:last-child,
	body.boryx-home-page .nav_mobile_top .nav_content > :last-child > *:first-child,
	body.boryx-home-page .nav_mobile_top .nav_content > :last-child > *:last-child {
		border-color: #f2d79a !important;
		color: #090b0e !important;
		background: linear-gradient(135deg, #f0d59d 0%, #c89542 58%, #f1cb82 100%) !important;
		box-shadow: 0 .06rem .18rem rgba(201, 154, 77, .24), 0 0 .14rem rgba(242, 184, 91, .12);
	}

	body.boryx-home-page .nav_mobile_top .nav_right > *:first-child *,
	body.boryx-home-page .nav_mobile_top .nav_right > *:last-child *,
	body.boryx-home-page .nav_mobile_top .nav_content > :last-child > *:first-child *,
	body.boryx-home-page .nav_mobile_top .nav_content > :last-child > *:last-child * {
		color: #090b0e !important;
	}

	body.boryx-home-page .nav_mobile_top .nav_right img,
	body.boryx-home-page .nav_mobile_top .nav_content > :last-child img {
		filter: brightness(0) saturate(100%) invert(83%) sepia(31%) saturate(652%) hue-rotate(352deg) brightness(97%) contrast(92%) drop-shadow(0 0 .05rem rgba(242, 184, 91, .22)) !important;
	}

	body.boryx-home-page .nav_mobile_top .nav_right > *:first-child img,
	body.boryx-home-page .nav_mobile_top .nav_right > *:last-child img,
	body.boryx-home-page .nav_mobile_top .nav_content > :last-child > *:first-child img,
	body.boryx-home-page .nav_mobile_top .nav_content > :last-child > *:last-child img {
		filter: brightness(0) saturate(100%) !important;
	}

	body.boryx-home-page .nav_mobile:not(.nav_mobile_top) .nav_content {
		border-color: rgba(232, 201, 138, .46) !important;
		box-shadow: 0 -.12rem .38rem rgba(0, 0, 0, .44), 0 0 .18rem rgba(201, 154, 77, .08), inset 0 1px rgba(255, 255, 255, .045);
	}

	body.boryx-home-page .nav_mobile:not(.nav_mobile_top) .nav_item {
		display: flex;
		align-items: center;
		justify-content: center;
		width: .49rem;
		height: .44rem;
		border: 1px solid transparent;
		border-radius: .15rem;
		box-sizing: border-box;
		transition: border-color .2s ease, background .2s ease, box-shadow .2s ease;
	}

	body.boryx-home-page .nav_mobile:not(.nav_mobile_top) .nav_item img {
		filter: grayscale(1) brightness(2.05) opacity(.78) !important;
	}

	body.boryx-home-page .nav_mobile:not(.nav_mobile_top) .nav_item:has(img[src*="_active"]) {
		border-color: rgba(242, 215, 154, .78);
		background: linear-gradient(145deg, rgba(240, 213, 157, .24), rgba(201, 154, 77, .1));
		box-shadow: 0 0 .2rem rgba(232, 201, 138, .22), inset 0 1px rgba(255, 255, 255, .05);
	}

	body.boryx-home-page .nav_mobile:not(.nav_mobile_top) .nav_item img[src*="_active"] {
		filter: brightness(0) saturate(100%) invert(83%) sepia(31%) saturate(652%) hue-rotate(352deg) brightness(102%) contrast(94%) drop-shadow(0 0 .09rem rgba(242, 184, 91, .65)) !important;
		transform: scale(1.08) translateY(-1px);
	}

	body.boryx-home-page .boryx-home-theme.home-mobile .content {
		padding-bottom: 0 !important;
	}

	body.boryx-home-page .boryx-home-theme.home-mobile .content .info-policy {
		padding-bottom: .12rem !important;
	}

	body.boryx-home-page #app,
	body.boryx-home-page #app > div {
		padding-bottom: max(.16rem, env(safe-area-inset-bottom));
		box-sizing: border-box;
	}

	body.boryx-home-page .boryx-home-theme.home-mobile {
		min-height: calc(100vh - .82rem);
		padding-bottom: calc(1.06rem + env(safe-area-inset-bottom));
	}
}
</style>

<!-- BORYX_HOME_V1_3_3_NAV_FIX -->
<style>
/* PC：登录和注册保持两个独立按钮，外层容器不形成大胶囊。 */
body.boryx-home-page .nav_pc .nav_right > .actions_content {
	display: flex !important;
	align-items: center !important;
	gap: .10rem !important;
	min-width: 0 !important;
	min-height: 0 !important;
	padding: 0 !important;
	border: 0 !important;
	border-radius: 0 !important;
	color: inherit !important;
	background: transparent !important;
	box-shadow: none !important;
	transform: none !important;
}

body.boryx-home-page .nav_pc .nav_right > .actions_content > * {
	display: inline-flex !important;
	align-items: center !important;
	justify-content: center !important;
	flex: 0 0 auto !important;
	width: auto !important;
	min-width: .82rem !important;
	height: .42rem !important;
	min-height: .42rem !important;
	padding: 0 .18rem !important;
	box-sizing: border-box !important;
	border: 1px solid rgba(232, 201, 138, .68) !important;
	border-radius: .23rem !important;
	color: #f0d59d !important;
	background: linear-gradient(135deg, rgba(232, 201, 138, .14), rgba(201, 154, 77, .04)) !important;
	box-shadow: inset 0 1px rgba(255, 255, 255, .045), 0 0 .16rem rgba(201, 154, 77, .08) !important;
	white-space: nowrap !important;
}

body.boryx-home-page .nav_pc .nav_right > .actions_content > * *,
body.boryx-home-page .nav_pc .nav_right > .actions_content > *:first-child * {
	color: #f0d59d !important;
	white-space: nowrap !important;
}

body.boryx-home-page .nav_pc .nav_right > .actions_content > *:last-child {
	border-color: #f2d79a !important;
	color: #090b0e !important;
	background: linear-gradient(135deg, #f0d59d 0%, #c89542 58%, #f1cb82 100%) !important;
	box-shadow: 0 .08rem .22rem rgba(201, 154, 77, .25), 0 0 .16rem rgba(242, 184, 91, .12) !important;
}

body.boryx-home-page .nav_pc .nav_right > .actions_content > *:last-child * {
	color: #090b0e !important;
}

@media (max-width: 1000px) {
	/* 删除旧首页为固定导航预留的 0.9rem 空白。 */
	body.boryx-home-page .boryx-home-theme.home-mobile {
		margin-top: 0 !important;
		padding-top: 0 !important;
	}

	body.boryx-home-page .boryx-home-theme.home-mobile > div:first-child {
		margin-top: 0 !important;
		padding-top: 0 !important;
	}

	body.boryx-home-page .nav_mobile_top.topPadding {
		top: 0 !important;
		height: calc(.74rem + env(safe-area-inset-top)) !important;
		min-height: calc(.74rem + env(safe-area-inset-top)) !important;
		margin: 0 !important;
		padding: env(safe-area-inset-top) 0 0 !important;
		box-sizing: border-box !important;
	}

	body.boryx-home-page .nav_mobile_top .nav_content {
		height: .74rem !important;
		min-height: .74rem !important;
		padding: .08rem .16rem !important;
		box-sizing: border-box !important;
	}

	body.boryx-home-page .nav_mobile_top .nav_left {
		flex: 1 1 auto !important;
		min-width: 0 !important;
	}

	body.boryx-home-page .nav_mobile_top .nav_right,
	body.boryx-home-page .nav_mobile_top .nav_content > :last-child {
		display: flex !important;
		align-items: center !important;
		justify-content: flex-end !important;
		flex: 0 0 auto !important;
		width: auto !important;
		min-width: 0 !important;
		gap: .045rem !important;
	}

	body.boryx-home-page .nav_mobile_top .nav_right > *,
	body.boryx-home-page .nav_mobile_top .nav_content > :last-child > * {
		display: inline-flex !important;
		align-items: center !important;
		justify-content: center !important;
		flex: 0 0 auto !important;
		width: .40rem !important;
		min-width: .40rem !important;
		max-width: none !important;
		height: .40rem !important;
		min-height: .40rem !important;
		padding: 0 !important;
		box-sizing: border-box !important;
		white-space: nowrap !important;
		word-break: keep-all !important;
		writing-mode: horizontal-tb !important;
		text-orientation: mixed !important;
		line-height: 1 !important;
	}

	body.boryx-home-page .nav_mobile_top .nav_right > *:first-child,
	body.boryx-home-page .nav_mobile_top .nav_content > :last-child > *:first-child {
		width: auto !important;
		min-width: .74rem !important;
		padding: 0 .12rem !important;
	}

	body.boryx-home-page .nav_mobile_top .nav_right > *:last-child,
	body.boryx-home-page .nav_mobile_top .nav_content > :last-child > *:last-child {
		width: auto !important;
		min-width: .56rem !important;
		padding: 0 .11rem !important;
		font-size: .14rem !important;
		white-space: nowrap !important;
		word-break: keep-all !important;
		writing-mode: horizontal-tb !important;
	}

	body.boryx-home-page .nav_mobile_top .nav_right > *:last-child *,
	body.boryx-home-page .nav_mobile_top .nav_content > :last-child > *:last-child * {
		display: inline-block !important;
		width: auto !important;
		max-width: none !important;
		white-space: nowrap !important;
		word-break: keep-all !important;
		writing-mode: horizontal-tb !important;
		line-height: 1 !important;
	}
}
</style>

<style>
/* V2.1.3 最终窄屏尺寸锁定：放在全部历史导航补丁之后。 */
body.boryx-home-page .nav_pc .nav_right > .lang,
body.boryx-home-page .nav_pc .nav_right > .lang:last-child {
	border-color: rgba(232, 201, 138, .58) !important;
	color: #f0d59d !important;
	background: linear-gradient(135deg, rgba(232, 201, 138, .14), rgba(201, 154, 77, .04)) !important;
	box-shadow: inset 0 1px rgba(255, 255, 255, .045), 0 0 .18rem rgba(201, 154, 77, .07) !important;
}

body.boryx-home-page .nav_pc .nav_right > .lang .lang_content,
body.boryx-home-page .nav_pc .nav_right > .lang .lang_content span,
body.boryx-home-page .nav_pc .nav_right > .lang:last-child .lang_content,
body.boryx-home-page .nav_pc .nav_right > .lang:last-child .lang_content span {
	color: #f0d59d !important;
}

@media (max-width: 1000px) {
	body.boryx-home-page .nav_mobile_top .nav_content {
		padding: .08rem .12rem !important;
		gap: .04rem !important;
	}
	body.boryx-home-page .nav_mobile_top .logo-container {
		flex: 0 0 .42rem !important;
		width: .42rem !important;
		height: .42rem !important;
		margin-right: .055rem !important;
	}
	body.boryx-home-page .nav_mobile_top .brand-stack span:first-child { font-size: .14rem !important; }
	body.boryx-home-page .nav_mobile_top .brand-stack span:last-child { font-size: .115rem !important; }
	body.boryx-home-page .nav_mobile_top .nav_right {
		flex: 0 0 auto !important;
		gap: .04rem !important;
		min-width: 0 !important;
	}
	body.boryx-home-page .nav_mobile_top .nav_right > .user_name:first-child {
		flex: 0 0 .62rem !important;
		width: .62rem !important;
		min-width: .62rem !important;
		max-width: .62rem !important;
		height: .36rem !important;
		min-height: .36rem !important;
		margin: 0 !important;
		padding: 0 .06rem !important;
		font-size: .12rem !important;
	}
	body.boryx-home-page .nav_mobile_top .nav_right > .action.sign {
		flex: 0 0 .36rem !important;
		width: .36rem !important;
		min-width: .36rem !important;
		max-width: .36rem !important;
		height: .36rem !important;
		min-height: .36rem !important;
		margin: 0 !important;
		padding: 0 !important;
	}
	body.boryx-home-page .nav_mobile_top .nav_right > .action.btn.sign:last-child {
		flex-basis: .52rem !important;
		width: .52rem !important;
		min-width: .52rem !important;
		max-width: .52rem !important;
		padding: 0 .06rem !important;
		font-size: .12rem !important;
	}
	body.boryx-home-page .nav_mobile_top .nav_right > .action.sign img {
		display: block !important;
		width: .18rem !important;
		height: .18rem !important;
		max-width: .18rem !important;
		max-height: .18rem !important;
		object-fit: contain !important;
	}
}

@media (max-width: 360px) {
	body.boryx-home-page .nav_mobile_top .nav_content {
		padding-left: .08rem !important;
		padding-right: .08rem !important;
		gap: .02rem !important;
	}
	body.boryx-home-page .nav_mobile_top .logo-container {
		flex-basis: .36rem !important;
		width: .36rem !important;
		height: .36rem !important;
		margin-right: .035rem !important;
	}
	body.boryx-home-page .nav_mobile_top .brand-stack span:first-child { font-size: .115rem !important; }
	body.boryx-home-page .nav_mobile_top .brand-stack span:last-child { font-size: .095rem !important; }
	body.boryx-home-page .nav_mobile_top .nav_right { gap: .025rem !important; }
	body.boryx-home-page .nav_mobile_top .nav_right > .user_name:first-child {
		flex-basis: .48rem !important;
		width: .48rem !important;
		min-width: .48rem !important;
		max-width: .48rem !important;
		padding: 0 .03rem !important;
		font-size: .105rem !important;
	}
	body.boryx-home-page .nav_mobile_top .nav_right > .action.sign {
		flex-basis: .32rem !important;
		width: .32rem !important;
		min-width: .32rem !important;
		max-width: .32rem !important;
		height: .32rem !important;
		min-height: .32rem !important;
	}
	body.boryx-home-page .nav_mobile_top .nav_right > .action.btn.sign:last-child {
		flex-basis: .44rem !important;
		width: .44rem !important;
		min-width: .44rem !important;
		max-width: .44rem !important;
		font-size: .105rem !important;
	}
}
</style>

<!-- BORYX_NAV_COMPACT_FINAL_FIX -->
<style>
/* 首页PC导航采用市场等4页的实际高度和宽度 */
@media (min-width: 1001px) {
  body.boryx-home-page #app.boryx-app-shell .nav_pc {
    width: 100% !important;
    max-width: 14.4rem !important;
    min-width: 0 !important;
    height: auto !important;
    min-height: 0 !important;
    margin: 0 auto !important;
    padding: .32rem 0 0 !important;
    box-sizing: border-box !important;
  }

  body.boryx-home-page #app.boryx-app-shell .nav_pc .nav_content {
    width: 100% !important;
    max-width: 14.4rem !important;
    height: auto !important;
    min-height: .82rem !important;
    margin: 0 auto !important;
    padding: 0 .6rem !important;
    box-sizing: border-box !important;
  }
}

/* 首页手机导航采用市场等4页的按钮尺寸 */
@media (max-width: 1000px) {
  body.boryx-home-page #app.boryx-app-shell .nav_mobile_top .nav_content {
    width: 100% !important;
    height: .74rem !important;
    min-height: .74rem !important;
    padding: .08rem .12rem !important;
    gap: .04rem !important;
    box-sizing: border-box !important;
  }

  body.boryx-home-page #app.boryx-app-shell .nav_mobile_top .nav_right {
    display: flex !important;
    flex: 0 0 auto !important;
    width: auto !important;
    min-width: 0 !important;
    margin: 0 !important;
    gap: .045rem !important;
    align-items: center !important;
    justify-content: flex-end !important;
  }

  body.boryx-home-page #app.boryx-app-shell .nav_mobile_top .nav_right > * {
    flex: 0 0 .4rem !important;
    width: .4rem !important;
    min-width: .4rem !important;
    max-width: .4rem !important;
    height: .4rem !important;
    min-height: .4rem !important;
    margin: 0 !important;
    padding: 0 !important;
    box-sizing: border-box !important;
  }

  /* 语言按钮：改成与市场相同的描边样式 */
  body.boryx-home-page #app.boryx-app-shell .nav_mobile_top .nav_right > .user_name:first-child {
    flex: 0 0 auto !important;
    width: auto !important;
    min-width: .62rem !important;
    max-width: none !important;
    height: .4rem !important;
    min-height: .4rem !important;
    padding: 0 .11rem !important;
    border: 1px solid rgba(232, 201, 138, .64) !important;
    border-radius: .2rem !important;
    color: #f0d59d !important;
    font-size: .13rem !important;
    background: rgba(201, 154, 77, .11) !important;
    box-shadow: inset 0 1px rgba(255,255,255,.04),
                0 0 .12rem rgba(201,154,77,.08) !important;
  }

  body.boryx-home-page #app.boryx-app-shell .nav_mobile_top .nav_right > .user_name:first-child * {
    color: #f0d59d !important;
  }

  /* 通知按钮保持稳定版的金色圆按钮；客服入口在导航组件内隐藏 */
  body.boryx-home-page #app.boryx-app-shell .nav_mobile_top .notice-container {
    border-color: #f2d79a !important;
    color: #090b0e !important;
    background: linear-gradient(
      135deg,
      #f0d59d,
      #c89542 58%,
      #f1cb82
    ) !important;
    box-shadow: 0 .06rem .17rem rgba(201,154,77,.24) !important;
  }

  /* 客服保持金色，与市场相同 */
  body.boryx-home-page #app.boryx-app-shell .nav_mobile_top .action.sign:not(.notice-container) {
    border-color: #f2d79a !important;
    color: #090b0e !important;
    background: linear-gradient(
      135deg,
      #f0d59d,
      #c89542 58%,
      #f1cb82
    ) !important;
    box-shadow: 0 .06rem .17rem rgba(201,154,77,.24) !important;
  }

  body.boryx-home-page #app.boryx-app-shell .nav_mobile_top .nav_right img {
    width: .21rem !important;
    height: .21rem !important;
    object-fit: contain !important;
  }

  body.boryx-home-page #app.boryx-app-shell .nav_mobile_top .action.sign:not(.notice-container) img {
    filter: brightness(.14) saturate(100%) !important;
  }

  body.boryx-home-page #app.boryx-app-shell .nav_mobile_top .notice-container img {
    filter: brightness(.14) saturate(100%) !important;
  }
}

@media (max-width: 360px) {
  body.boryx-home-page #app.boryx-app-shell .nav_mobile_top .nav_content {
    padding: .08rem !important;
    gap: .02rem !important;
  }

  body.boryx-home-page #app.boryx-app-shell .nav_mobile_top .nav_right > .user_name:first-child {
    min-width: .56rem !important;
    height: .36rem !important;
    min-height: .36rem !important;
    padding: 0 .08rem !important;
    font-size: .115rem !important;
  }

  body.boryx-home-page #app.boryx-app-shell .nav_mobile_top .nav_right > .action.sign {
    flex-basis: .36rem !important;
    width: .36rem !important;
    min-width: .36rem !important;
    max-width: .36rem !important;
    height: .36rem !important;
    min-height: .36rem !important;
  }
}
</style>
<!-- /BORYX_NAV_COMPACT_FINAL_FIX -->
<!-- BORYX_V234_HOME_NAV_LOCK_BEGIN -->
<style>
@media (min-width: 1001px) {
  body.boryx-home-page #app.boryx-app-shell.route-home .nav_pc .nav_right > .service {
    flex: 0 0 .52rem !important; width: .52rem !important; min-width: .52rem !important; max-width: .52rem !important;
    height: .42rem !important; min-height: .42rem !important; padding: 0 !important; margin: 0 !important;
  }
  body.boryx-home-page #app.boryx-app-shell.route-home .nav_pc .nav_right > .lang {
    flex: 0 0 .82rem !important; width: .82rem !important; min-width: .82rem !important; max-width: .82rem !important;
    height: .42rem !important; min-height: .42rem !important; padding: 0 .12rem !important; margin: 0 !important;
  }
}
@media (max-width: 1000px) {
  body.boryx-home-page #app.boryx-app-shell.route-home .nav_mobile_top .nav_right { gap: .045rem !important; }
  body.boryx-home-page #app.boryx-app-shell.route-home .nav_mobile_top .nav_right > * {
    flex: 0 0 .36rem !important; width: .36rem !important; min-width: .36rem !important; max-width: .36rem !important;
    height: .36rem !important; min-height: .36rem !important; padding: 0 !important; margin: 0 !important;
  }
  body.boryx-home-page #app.boryx-app-shell.route-home .nav_mobile_top .nav_right > .user_name:first-child {
    flex-basis: .58rem !important; width: .58rem !important; min-width: .58rem !important; max-width: .58rem !important;
    padding: 0 .06rem !important; font-size: .12rem !important;
  }
}
</style>
<!-- BORYX_V234_HOME_NAV_LOCK_END -->
